
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(264|68|703|920)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
